import React, { useLayoutEffect, useRef } from "react";
import "./webaudio-controls/webaudio-controls-module";
export const WebAudioSlider = (props) => {
    const ref = useRef(null);
    useLayoutEffect(() => {
        const { current } = ref;
        if (current !== undefined) {
            // @ts-ignore
            current === null || current === void 0 ? void 0 : current.addEventListener("input", (event) => {
                props.onSliderInput &&
                    (props === null || props === void 0 ? void 0 : props.onSliderInput(parseFloat(event.target.value)));
                props.onSliderEvent && (props === null || props === void 0 ? void 0 : props.onSliderEvent(event));
            });
        }
    }, [ref]);
    // @ts-ignore
    return (React.createElement("webaudio-slider", { id: (props === null || props === void 0 ? void 0 : props.id) ? props.id : "slider", ref: ref, ...props }));
};
